








































































import Vue from "vue";
import { firestore } from "firebase/app";
import { db } from "@/main";
import EditBlog from "@/components/EditBlog.vue";
import algoliasearch from "algoliasearch";
import constants from "../constants/constants";
import firebase from "firebase";
import { Blog } from "../models/blog";

export default Vue.extend({
  name: "Blogs",
  components: {
    EditBlog
  },
  data() {
    return {
      selectedBlog: "",
      search: null,
      showSnackbar: false,
      snackbarColor: "",
      snackbarText: "",
      showModalValue: false,
      footerProps: { "items-per-page-options": [20, 50, 100, 200, 500, 1000] },
      headers: [
        { value: "title", text: "Title", sortable: true },
        { value: "subtitle", text: "Subtitle", sortable: true },
        { value: "category", text: "Category", sortable: true },
        { value: "author", text: "Author", sortable: true },
        { value: "likes", text: "Likes", sortable: false },
        { value: "views", text: "Views", sortable: false },
        { value: "isLive", text: "Live", sortable: false }
      ],
      options: {},
      page: 1,
      totalRows: 0,
      perPage: { value: 50, text: "50 per page" },
      blog: {} as Blog,
      blogs: [] as Blog[],
      client: algoliasearch(
        constants.ALGOLIA.APP_ID,
        constants.ALGOLIA.SEARCH_KEY
      ),
      topVisible: {} as firebase.firestore.QueryDocumentSnapshot,
      bottomVisible: {} as firebase.firestore.QueryDocumentSnapshot,
      searchResults: [],
      isBusy: false,
      isSearchLoading: false,
      tags: [],
      headingText: "Blog Entries",
      previousPageNumber: 1
    };
  },
  methods: {
    updateShowModalValue(value: boolean) {
      this.showModalValue = value;
    },
    addBlog() {
      this.blog = {
        uid: db.collection("blogs").doc().id,
        author: `${this.$store.state.currentUser.name} ${this.$store.state.currentUser.surname}`,
        category: "",
        dateCreated: firebase.firestore.Timestamp.now(),
        likes: 0,
        views: 0,
        title: "",
        subtitle: "",
        text: "",
        isLive: false
      };
      this.showModalValue = true;
    },
    async deleteBlog(blog: Blog) {
      this.isBusy = true;
      db.collection("blogs")
        .doc(blog.uid)
        .delete()
        .then(_ => {
          this.isBusy = false;
          this.showSnackbar = true;
          this.snackbarText = "Successfuly deleted blog.";
          this.snackbarColor = "success";
          this.initData();
        })
        .catch(error => {
          this.isBusy = false;
          console.log(error);
          this.showSnackbar = true;
          this.snackbarText = error;
          this.snackbarColor = "error";
        });
    },
    async saveData(blog: Blog, file: File) {
      this.isBusy = true;
      if (file.name) {
        console.log("file:", file);

        const downloadUrl = await this.uploadImage(file);
        blog.imageUrl = downloadUrl;
      }
      console.log(blog);
      db.collection("blogs")
        .doc(blog.uid)
        .set(blog, { merge: true })
        .then(_ => {
          this.isBusy = false;
          this.showSnackbar = true;
          this.snackbarText = "Successfuly added blog.";
          this.snackbarColor = "success";
          this.initData();
        })
        .catch(error => {
          this.isBusy = false;
          console.log(error);
          this.showSnackbar = true;
          this.snackbarText = error;
          this.snackbarColor = "error";
        });
    },
    uploadImage(imageFile: File): Promise<any> {
      const storage = firebase.storage();
      const storageRef = storage.ref();
      const imagesRef = storageRef.child(
        `titleImages/${this.blog.uid}-${imageFile.name}`
      );
      return new Promise((resolve, reject) => {
        imagesRef.put(imageFile).then(function(snapshot) {
          snapshot.ref
            .getDownloadURL()
            .then(function(downloadURL) {
              resolve(downloadURL);
              console.log("File available at", downloadURL);
            })
            .catch((error: Error) => {
              reject(error);
            });
        });
      });
    },
    initData() {
      this.getTotalBlogsCount();
      this.getData();
    },
    getTotalBlogsCount() {
      this.algoliaClient
        .search("", {})
        .then(({ nbHits }: any) => {
          this.totalRows = nbHits;
        })
        .catch((err: any) => {
          console.log(err);
          return null;
        });
    },
    getSearchResults(value: string) {
      this.isSearchLoading = true;
      this.algoliaClient
        .search(value, {
          hitsPerPage: 5
        })
        .then(({ hits }: any) => {
          this.isSearchLoading = false;
          this.searchResults = hits.map((hit: any) => {
            const item = { ...hit };
            delete item.objectID;
            const blog = item as Blog;
            return {
              value: blog.uid,
              text: `${blog.title} | ${blog.subtitle}`
            };
          });
        })
        .catch((err: any) => {
          this.isSearchLoading = false;
          console.log(err);
          return null;
        });
    },
    getData() {
      const { sortBy, sortDesc, page, itemsPerPage }: any = this.options;
      this.isBusy = true;
      let query: any = this.mainQuery;
      let order: "asc" | "desc" = "asc";
      let sort = "category";
      if (sortBy && sortBy.length > 0) {
        sort = sortBy[0];
      }
      if (sortDesc !== undefined && sortDesc.length > 0) {
        order = sortDesc[0] ? "desc" : "asc";
      }
      query = query.orderBy(sort, order);
      const pageDiff = (page ?? 1) - this.previousPageNumber;
      this.previousPageNumber = page ?? 1;
      switch (pageDiff) {
        case 0:
          query = query.limit(itemsPerPage ?? this.perPage.value);
          break;
        case 1:
          query = query
            .startAfter(this.bottomVisible)
            .limit(itemsPerPage ?? this.perPage.value);
          break;
        case -1:
          query = query
            .endBefore(this.topVisible)
            .limitToLast(itemsPerPage ?? this.perPage.value);
          break;
        default:
          query = query.limit(itemsPerPage ?? this.perPage.value);
      }
      query
        .get()
        .then((snapshot: firebase.firestore.QuerySnapshot) => {
          this.isBusy = false;
          if (snapshot.docs.length > 0) {
            this.blogs = snapshot.docs.map(value => value.data() as Blog);
            this.topVisible = snapshot.docs[0];
            this.bottomVisible = snapshot.docs[snapshot.docs.length - 1];
          }
        })
        .catch((error: Error) => {
          console.log(error);
          this.isBusy = false;
        });
    },
    selectedRow(item: Blog, row: number) {
      //   router.push({ name: 'BlogDetails', params: { uid: item.uid } });
      this.blog = item;
      this.showModalValue = true;
    }
  },
  watch: {
    search(val) {
      if (val) {
        this.getSearchResults(val);
      } else {
        this.searchResults = [];
      }
    },
    selectedBlog() {
      if (this.selectedBlog) {
        // router.push({ name: 'BlogDetails', params: { uid: this.selectedBlog } });
        db.collection("blogs")
          .doc(this.selectedBlog)
          .get()
          .then(doc => {
            this.blog = doc.data() as Blog;
            this.showModalValue = true;
          });
      }
    },
    options: {
      handler() {
        this.getData();
      },
      deep: true
    }
  },
  created() {
    this.initData();
  },
  computed: {
    algoliaClient() {
      return (this as any).client.initIndex(constants.ALGOLIA.INDEXES.BLOGS);
    },
    mainQuery() {
      const queryRef = db.collection("blogs");
      return queryRef;
    }
  }
});
